module.exports = __webpack_public_path__ + "img/touxiang.ca6aeb11.png";